import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import {
  LEARNED_AUTO_FILL_LIBRARY_STORAGE_KEY,
  LEARNED_AUTO_FILL_LIBRARY_VERSION,
  sanitizeLearnedAutoFillPatterns,
  type LearnedAutoFillPatternV1,
} from '../lib/quickFill/learnedAutoFillLibrary';
import {
  getDurableStateStorage,
  registerDurableRehydrator,
} from '../lib/durableState/durableState';

interface LearnedAutoFillLibraryState {
  entries: LearnedAutoFillPatternV1[];
  replaceEntries: (entries: readonly LearnedAutoFillPatternV1[]) => void;
  reset: () => void;
}

export const useLearnedAutoFillLibraryStore = create<LearnedAutoFillLibraryState>()(
  persist(
    (set) => ({
      entries: [],
      replaceEntries: (entries) => set({ entries: sanitizeLearnedAutoFillPatterns(entries) }),
      reset: () => set({ entries: [] }),
    }),
    {
      name: LEARNED_AUTO_FILL_LIBRARY_STORAGE_KEY,
      version: LEARNED_AUTO_FILL_LIBRARY_VERSION,
      storage: createJSONStorage(getDurableStateStorage),
      partialize: (state) => ({ entries: state.entries }),
      merge: (persistedState, currentState) => ({
        ...currentState,
        entries: sanitizeLearnedAutoFillPatterns(
          typeof persistedState === 'object' && persistedState !== null
            ? (persistedState as { entries?: unknown }).entries
            : null
        ),
      }),
    }
  )
);

registerDurableRehydrator(() => useLearnedAutoFillLibraryStore.persist.rehydrate());
